export default __webpack_public_path__ + "static/media/office-building.368181bc.svg";